var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconChatX95Jpd8Fl2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#192835;}.cls-2{fill:#4891d3;}.cls-3{fill:#f5de0a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,9.3a1,1,0,0,0-1,.26,1,1,0,0,0-.24,1A5,5,0,0,1,37,12V25a5,5,0,0,1-5,5H19a1,1,0,0,0-.71.29l-3.92,3.92a1,1,0,0,0-.25,1,1,1,0,0,0,.76.69A5.42,5.42,0,0,0,16,36H28.59l6.7,6.71A1,1,0,0,0,36,43a.84.84,0,0,0,.38-.08A1,1,0,0,0,37,42V35.93A7,7,0,0,0,43,29V16A7,7,0,0,0,38,9.3ZM41,29a5,5,0,0,1-5,5,1,1,0,0,0-1,1v4.59l-5.29-5.3A1,1,0,0,0,29,34H17.41l2-2H32a7,7,0,0,0,7-7V12a5,5,0,0,1,2,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41,16V29a5,5,0,0,1-5,5,1,1,0,0,0-1,1v4.59l-5.29-5.3A1,1,0,0,0,29,34H17.41l2-2H32a7,7,0,0,0,7-7V12A5,5,0,0,1,41,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.7,10A7,7,0,0,0,32,5H12a7,7,0,0,0-7,7V25a7,7,0,0,0,5,6.7,7.43,7.43,0,0,0,1,.23V38a1,1,0,0,0,.62.92A.84.84,0,0,0,12,39a1,1,0,0,0,.71-.29L19.41,32H32a7,7,0,0,0,7-7V12A6.88,6.88,0,0,0,38.7,10ZM37,25a5,5,0,0,1-5,5H19a1,1,0,0,0-.71.29L13,35.59V31a1,1,0,0,0-1-1,4.72,4.72,0,0,1-1.45-.22A5,5,0,0,1,7,25V12a5,5,0,0,1,5-5H32a5,5,0,0,1,5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37,12V25a5,5,0,0,1-5,5H19a1,1,0,0,0-.71.29L13,35.59V31a1,1,0,0,0-1-1,4.72,4.72,0,0,1-1.45-.22A5,5,0,0,1,7,25V12a5,5,0,0,1,5-5H32a5,5,0,0,1,5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,15H12a1,1,0,0,1,0-2H32a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,20H12a1,1,0,0,1,0-2H32a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,25H12a1,1,0,0,1,0-2H32a1,1,0,0,1,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconChatX95Jpd8Fl2);
export default __webpack_public_path__ + "static/media/reshot-icon-chat-X95JPD8FL2.62f852c0aa33caa05c6e6f41675f60c0.svg";
export { ForwardRef as ReactComponent };